const CREATE_SESSION = "[session][user]create.session";
const REMOVE_SESSION = "[session][user]remove.session";
const LOAD_SESSION = "[session][user]load.session";
const SET_PUBLIC_EXAM_USER_NAME = "[session][user]set.public.exam.user.name";

export {CREATE_SESSION, REMOVE_SESSION, LOAD_SESSION, SET_PUBLIC_EXAM_USER_NAME}